import { USE_LEGACY_SMB_GUIDED_SETUP } from '../../configs/guidedSetup'
import { IPlanningSmbGuidedWizardProps } from '../../model/guidedWizardTypes'
import { PlanningSmbGuidedModal } from '../planningSmbGuidedModal/PlanningSmbGuidedModal'
import { PlanningSmbGuidedWizardModal } from '../planningSmbGuidedWizard/PlanningSmbGuidedWizardModal'

/** Both Guided Setup buttons use the same version flag and the same Offering context. */
export const PlanningSmbGuidedSetup = (props: IPlanningSmbGuidedWizardProps) =>
  USE_LEGACY_SMB_GUIDED_SETUP ? (
    <PlanningSmbGuidedModal {...props} />
  ) : (
    <PlanningSmbGuidedWizardModal {...props} />
  )
